import React, { useEffect, useState } from "react";
import { collection_activity_item_data } from "../../data/collection_data";
import Link from "next/link";
import Image from "next/image";
import {
  getTotalActivity,
  getCollectionActivity,
  getUserActivity,
} from "../../utils/api";
import {
  useCosmWasmClient,
  useSigningCosmWasmClient,
  useWallet,
  WalletConnectButton,
} from "@sei-js/react";
import LoadingComp from "../loading/loading";
const Activity_item = () => {
  const [filterVal, setFilterVal] = useState(null);
  const [limit, setLimit] = useState(0);
  const [activity, setActivity] = useState([]);
  const [filterType, setFilterType] = useState("all");
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);
  const { accounts } = useWallet();

  console.log(filterType);

  function onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }

  const [data, setData] = useState(collection_activity_item_data);
  const [filterData, setfilterData] = useState(
    collection_activity_item_data.map((item) => {
      const { category } = item;
      return category;
    })
  );

  const [inputText, setInputText] = useState("");

  const handleFilter = (category) => {
    setData(
      collection_activity_item_data.filter((item) => item.category === category)
    );
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    const newArray = collection_activity_item_data.filter((item) => {
      return item.title.toLowerCase().includes(inputText);
    });
    setData(newArray);
    setInputText("");
  };

  const filteredData = activity.filter((item) => {
    let collectionMatch;
    try {
      const metadataJson = JSON.parse(item.metadata);
      const nameLowerCase = metadataJson.name?.replace(/\s/g, "").toLowerCase();
      const searchTermLowerCase = searchTerm?.replace(/\s/g, "").toLowerCase();

      collectionMatch = nameLowerCase.includes(searchTermLowerCase);
    } catch (error) {
      // Handle JSON parsing errors
      console.error("Error parsing metadata:", error);
    }
    if (filterType === "all") {
      return collectionMatch;
    } else if (filterType === "listed") {
      return collectionMatch && item.sold === null;
    } else if (filterType === "sold") {
      return collectionMatch && item.sold !== null;
    }
    return true;
  });
  console.log(filteredData);

  const handleFilters = (type) => {
    setFilterType(type);
  };
  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };

  useEffect(() => {
    if (
      window.location.pathname.includes("user") &&
      window.location.pathname.includes("avatar")
    ) {
      try {
        setLoading(true);
        if (accounts.length <= 0) return;
        const data = {
          user: accounts[0]?.address,
          subquery: limit,
        };
        console.log("data: ", data);
        getUserActivity(data).then((data) => {
          console.log("userActivity: ", data);
          setActivity(data.reverse());
        });
      } catch (error) {
        console.error("Error fetching collection listings:", error);
      } finally {
        setLoading(false);
      }
    }

    if (window.location.pathname.includes("collection/")) {
      try {
        setLoading(true);
        const data = {
          collection: window.location.pathname.split("collection/")[1],
          subquery: limit,
        };
        getCollectionActivity(data).then((data) => {
          console.log("collectionActivity: ", data);
          setActivity(data.reverse());
        });
      } catch (error) {
        console.error("Error fetching collection listings:", error);
      } finally {
        setLoading(false);
      }
    }

    if (window.location.pathname.includes("activity")) {
      try {
        setLoading(true);
        const data = {
          collection: "all",
          subquery: limit,
        };
        getTotalActivity(data).then((data) => {
          console.log("totalActivity: ", data);
          setActivity(data.reverse());
        });
      } catch (error) {
        console.error("Error fetching collection listings:", error);
      } finally {
        setLoading(false);
      }
    }
  }, []);

  return (
    <>
      {/* <!-- Activity Tab --> */}
      <div className="tab-pane fade">
        {/* <!-- Records / Filter --> */}
        <div className="lg:flex">
          {/* <!-- Records --> */}
          <div className="mb-10 shrink-0 basis-8/12 space-y-5 lg:mb-0 lg:pr-10">
            {loading ? (
              <div className="loading_box">
                <LoadingComp />
              </div>
            ) : (
              filteredData.map((item) => {
                const { id, image, title, price, time, category } = item;
                return (
                  <Link href={""} key={id}>
                    <a className="dark:bg-jacarta-700 dark:border-jacarta-700 border-jacarta-100 rounded-2.5xl relative flex items-center border bg-white p-8 transition-shadow hover:shadow-lg">
                      <figure className="mr-5 self-start">
                        <img
                          src={JSON.parse(item?.metadata).image}
                          alt={JSON.parse(item?.metadata).name}
                          height={50}
                          width={50}
                          objectfit="cover"
                          className="rounded-2lg"
                          loading="lazy"
                        />
                      </figure>

                      <div>
                        <h3 className="font-display text-jacarta-700 mb-1 text-base font-semibold dark:text-white">
                          {JSON.parse(item?.metadata).name}
                        </h3>
                        <span className="dark:text-jacarta-200 text-jacarta-500 mb-3 block text-sm">
                          {JSON.parse(item?.metadata)?.price}
                        </span>
                        <span className="text-jacarta-300 block text-xs">
                          {item?.sold
                            ? item.sold.split(".")[0]
                            : item?.listing_time.split(".")[0]}
                        </span>
                      </div>

                      <div className="dark:border-jacarta-600 border-jacarta-100 ml-auto rounded-full border p-3">
                        {item?.sold ? "Sold" : "List"}
                        {/* <svg className="icon fill-jacarta-700 dark:fill-white h-6 w-6">
                          <use xlinkHref={`/icons.svg#icon-${category}`}></use>
                        </svg> */}
                      </div>
                    </a>
                  </Link>
                );
              })
            )}
          </div>

          {/* <!-- Filters --> */}
          <aside className="basis-4/12 lg:pl-5">
            <form
              action="search"
              className="relative mb-12 block"
              onSubmit={handleSubmit}
            >
              <input
                type="search"
                className="text-jacarta-700 placeholder-jacarta-500 focus:ring-accent border-jacarta-100 w-full rounded-2xl border py-[0.6875rem] px-4 pl-10 dark:border-transparent dark:bg-white/[.15] dark:text-white dark:placeholder-white"
                placeholder="Search by Collection"
                onChange={handleSearch}
              />
              <button
                type="submit"
                className="absolute left-0 top-0 flex h-full w-12 items-center justify-center rounded-2xl"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="24"
                  height="24"
                  className="fill-jacarta-500 h-4 w-4 dark:fill-white"
                >
                  <path fill="none" d="M0 0h24v24H0z"></path>
                  <path d="M18.031 16.617l4.283 4.282-1.415 1.415-4.282-4.283A8.96 8.96 0 0 1 11 20c-4.968 0-9-4.032-9-9s4.032-9 9-9 9 4.032 9 9a8.96 8.96 0 0 1-1.969 5.617zm-2.006-.742A6.977 6.977 0 0 0 18 11c0-3.868-3.133-7-7-7-3.868 0-7 3.132-7 7 0 3.867 3.132 7 7 7a6.977 6.977 0 0 0 4.875-1.975l.15-.15z"></path>
                </svg>
              </button>
            </form>

            <h3 className="font-display text-jacarta-500 mb-4 font-semibold dark:text-white">
              Filters
            </h3>
            <div className="flex flex-wrap">
              {filterData.map((category, i) => {
                return (
                  <button
                    className={
                      filterVal === i
                        ? "dark:border-jacarta-600 group bg-accent border-jacarta-100 mr-2.5 mb-2.5 inline-flex items-center rounded-xl border px-4 py-3 border-transparent text-white dark:border-transparent"
                        : "dark:border-jacarta-600 dark:bg-jacarta-700 group dark:hover:bg-accent hover:bg-accent border-jacarta-100 mr-2.5 mb-2.5 inline-flex items-center rounded-xl border bg-white px-4 py-3 hover:border-transparent hover:text-white dark:text-white dark:hover:border-transparent"
                    }
                    key={i}
                    onClick={() => {
                      handleFilters(category);
                      setFilterVal(i);
                    }}
                  >
                    <svg
                      className={
                        filterVal === i
                          ? "icon mr-2 h-4 w-4 fill-white"
                          : "icon fill-jacarta-700 mr-2 h-4 w-4 group-hover:fill-white dark:fill-white"
                      }
                    >
                      <use xlinkHref={`/icons.svg#icon-${category}`}></use>
                    </svg>
                    <span className="text-2xs font-medium capitalize">
                      {category}
                    </span>
                  </button>
                );
              })}
            </div>
          </aside>
        </div>
      </div>
    </>
  );
};

export default Activity_item;
